import { Avatar } from '@mui/material';
import React from 'react';
import { IAgentAvatar } from './interfaces';

export const AgentAvatar: React.FC<IAgentAvatar> = ({
  agent,
  variant = undefined,
  sx,
}): JSX.Element => {
  const avatarSize = (() => {
    if (variant === 'pill') {
      return '25px';
    }

    if (variant === 'table-row') {
      return '35px';
    }

    if (variant === 'profile') {
      return '100px';
    }

    return undefined;
  })();

  const avatarFontSize = (() => {
    if (variant === 'pill') {
      return '14px';
    }

    if (variant === 'table-row') {
      return '18px';
    }

    if (variant === 'profile') {
      return '30px';
    }

    return undefined;
  })();

  return (
    <Avatar
      alt={`${agent.firstName} ${agent.lastName}`}
      src={`${process.env.REACT_APP_API_URL}/agents/avatar/${agent.avatar}`}
      sx={{
        width: avatarSize,
        height: avatarSize,
        border: (theme) => `2px solid ${theme.palette.primary.main}`,
        bgcolor: (theme) => theme.palette.primary.main,
        fontSize: avatarFontSize,
        ...sx,
      }}
    />
  );
};
